import Phaser from 'phaser';
import { getItemImagePath, itemTextureKey } from '../items';

export function fitItemIcon(image: Phaser.GameObjects.Image, slotSize: number, fill = 0.7) {
  const fw = image.frame?.width || slotSize;
  const fh = image.frame?.height || slotSize;
  const max = slotSize * fill;
  const scale = Math.min(max / fw, max / fh);
  image.setDisplaySize(fw * scale, fh * scale);
}

export function ensureItemTexture(scene: Phaser.Scene, name: string): Promise<string | null> {
  const key = itemTextureKey(name);
  if (scene.textures.exists(key)) return Promise.resolve(key);

  const path = getItemImagePath(name);
  if (!path) return Promise.resolve(null);

  return new Promise((resolve) => {
    const done = () => {
      scene.load.off('complete', done);
      resolve(scene.textures.exists(key) ? key : null);
    };
    scene.load.once('complete', done);
    scene.load.image(key, path);
    if (!scene.load.isLoading()) scene.load.start();
  });
}
